import { InjectionToken } from '@angular/core';

export const ABTEST_WHITELIST_COOKIE = new InjectionToken<string>(
  'ABTestWhitelistCookie',
);
